import React from "react";

const GuestCountInput = ({
  guestCount,
  incrementGuestCount,
  decrementGuestCount,
}) => {
  return (
    <div className="form-group">
      <label htmlFor="guestCount">Number of Guests</label>
      <div className="guest-count-container">
        <button
          type="button"
          className="guest-count-btn"
          onClick={decrementGuestCount}
          disabled={guestCount <= 0}
        >
          -
        </button>
        <span className="guest-count-display">{guestCount}</span>
        <button
          type="button"
          className="guest-count-btn"
          onClick={incrementGuestCount}
          disabled={guestCount >= 10}
        >
          +
        </button>
      </div>
      <div className="instructions" >
        Select the number of guests you
would like to RSVP for using the plus and minus buttons. Start typing a name on the “Search
guest name” lines and select the name from the drop-down
list. Then click on “Yes” or “No” to RSVP for that guest.
      </div>
      <div className="instructions ">If you have any issues please reach out to Jordan & Morgan at 330-936-7465!</div>
    </div>
  );
};

export default GuestCountInput;
